import { Components, Theme } from '@mui/material';

export const buttonStyles: Components<Theme>['MuiButton'] = {
  defaultProps: {
    disableRipple: true
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      fontWeight: '700',
      padding: '14px 20px',
      fontSize: '16px',
      lineHeight: '24px',
      borderRadius: 0,
      color:
        ownerState.color === 'inherit'
          ? theme.palette.primary.main
          : `${theme.palette[ownerState.color || 'primary'].main}`,
      textTransform: 'none',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '8px',
      overflow: 'hidden',
      border: 'none',
      boxShadow: 'none',
      '&.rounded': {
        borderRadius: '50px'
      }
    }),
    contained: ({ theme }) => ({
      color: theme.palette.white,
      background: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      '&:hover': {
        background: theme.palette.customGrey.dark,
        borderColor: theme.palette.customGrey.dark,
        boxShadow: 'none'
      },
      '&:disabled': {
        background: theme.palette.customGrey.medium,
        color: theme.palette.white,
        border: 'none'
      }
    }),
    outlined: ({ theme, ownerState }) => ({
      backgroundColor: theme.palette.white,
      border: `1px solid ${theme.palette.primary.main}`,
      borderWidth: 1,
      color:
        ownerState.color === 'inherit'
          ? theme.palette.primary.main
          : `${theme.palette[ownerState.color || 'primary'].main}`,
      borderColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.white,
        borderColor: theme.palette.customGrey.dark,
        color: theme.palette.customGrey.dark,
        boxShadow: 'none'
      }
    }),
    text: ({ theme }) => ({
      '&:hover': {
        color: theme.palette.customGrey.dark,
        backgroundColor: 'transparent'
      }
    }),
    textError: ({ theme }) => ({
      color: theme.palette.error.main
    })
  }
};
